import { useEffect, useMemo, useState } from 'react';
import { Capacitor } from '@capacitor/core';

function detectTablet(): boolean {
  const shortestSide = Math.min(window.innerWidth, window.innerHeight);
  const hasCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
  return shortestSide >= 600 && hasCoarsePointer;
}

function detectLandscape(): boolean {
  if (typeof window.screen?.orientation?.type === 'string') {
    return window.screen.orientation.type.startsWith('landscape');
  }
  return window.innerWidth > window.innerHeight;
}

export function useTabletOrientationGuard(isFollowingRoute: boolean) {
  const isNative = Capacitor.isNativePlatform();
  const [isTablet, setIsTablet] = useState<boolean>(() => detectTablet());
  const [isLandscape, setIsLandscape] = useState<boolean>(() => detectLandscape());

  useEffect(() => {
    const update = () => {
      setIsTablet(detectTablet());
      setIsLandscape(detectLandscape());
    };
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    window.screen?.orientation?.addEventListener?.('change', update);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
      window.screen?.orientation?.removeEventListener?.('change', update);
    };
  }, []);

  const mustRotateForFollow = useMemo(
    () => isNative && isTablet && isFollowingRoute && !isLandscape,
    [isNative, isTablet, isFollowingRoute, isLandscape]
  );

  return { isNative, isTablet, isLandscape, mustRotateForFollow };
}
